import { Component, Input, WritableSignal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteFormResult } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { MORE_OPTIONS_SELECTOR, allOption, bikeOption, busOption, walkOption } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/constants';
import { MoreOptions } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/models';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslocoPipe } from '@ngneat/transloco';
import { FormsModule } from '@angular/forms';
import { RouteItineraryBannersComponents } from './components/route-itinerary-banners/route-itinerary-banners.component';
import { ShowDurationDirective } from '@shared/directives/show-duration.directive';
import { CoreService } from '@core/services';

@Component({
  selector: 'app-route-results-options',
  standalone: true,
  imports: [CommonModule, MatButtonToggleModule, MatIconModule, FormsModule, TranslocoPipe, RouteItineraryBannersComponents, ShowDurationDirective],
  templateUrl: './route-results-options.component.html',
  styleUrls: ['./route-results-options.component.scss']
})
export class RouteResultsOptionsComponent {

  @Input({required: true}) routeFormResults!: WritableSignal<RouteFormResult|null>;
  @Input({required: true}) optionSelected!: WritableSignal<MoreOptions>;

  private indexItinerarySelected = inject(CoreService).itineraryIndexSelected;

  public busId = busOption.id;
  public walkId= walkOption.id;
  public bicycleId = bikeOption.id
  public allId = allOption.id

  public moreOptionsSelector = MORE_OPTIONS_SELECTOR;

  public optionSelectedChange(option: MoreOptions){
    this.optionSelected.set(option);
    this.indexItinerarySelected.set(-1);
  }


}
